package devxertech.com.pages.dashboard.serviceAndTechSection

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.CommonButton
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px

@Composable
fun ServicesSectionBox() {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()
    val ctx = rememberPageContext()
    val titleModifier = Modifier
        .margin(bottom = 10.px).fontSize(28.71.px)
        .fontFamily(Constants.FONT_FAMILY)
        .fontWeight(FontWeight.Bold)
//        .textAlign(TextAlign.Center)
        .fontSize(if (breakpoint > Breakpoint.MD) 28.px else if (window.screen.width < 375) 20.px else 24.px)
        .color(sitePalette.commonSecondaryButtonColor.rgb)
    val descriptionModifier = Modifier.fontSize(13.px).color(sitePalette.textFieldTextColor.rgb)
        .width(if (breakpoint > Breakpoint.MD) 500.px else if (window.screen.width < 375) 270.px else 350.px)
        .height(60.px)
        .textAlign(if (breakpoint <= Breakpoint.MD) TextAlign.Center else TextAlign.Left)
        .fontFamily(Constants.FONT_FAMILY).margin(topBottom = 10.px)

    var selectedService by remember { mutableStateOf("Web Design & Development") }
    val services = listOf(
        "Web Design & Development",
        "Mobile App Development",
        "Dev Operation",
        "Al Development",
        "UI/UX Design",
        "AI Chatbot Development"
    )

    LaunchedEffect(Unit) {
        while (true) {
            delay(3000L)
            selectedService = services[(services.indexOf(selectedService) + 1) % services.size]
        }
    }
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .margin(topBottom = 30.px),
        horizontalArrangement = Arrangement.Center,
    ) {
        if (breakpoint > Breakpoint.LG) {
            ServicesNameBox(
                "Web Design & Development",
                selected = selectedService == "Web Design & Development",

                ) { selectedService = "Web Design & Development" }

            Box(modifier = Modifier.width(25.px)) {}
            ServicesNameBox(
                "Mobile App Development",
                selected = selectedService == "Mobile App Development",

                ) { selectedService = "Mobile App Development" }

            Box(modifier = Modifier.width(25.px)) {}
            ServicesNameBox(
                "Dev Operation",
                selected = selectedService == "Dev Operation",

                ) { selectedService = "Dev Operation" }

            Box(modifier = Modifier.width(25.px)) {}
            ServicesNameBox(
                "Al Development",
                selected = selectedService == "Al Development",

                ) { selectedService = "Al Development" }

            Box(modifier = Modifier.width(25.px)) {}
            ServicesNameBox(
                "UI/UX Design",
                selected = selectedService == "UI/UX Design",

                ) { selectedService = "UI/UX Design" }

            Box(modifier = Modifier.width(25.px)) {}
            ServicesNameBox(
                "AI Chatbot Development",
                selected = selectedService == "AI Chatbot Development",

                ) { selectedService = "AI Chatbot Development" }
        } else {
            Box(
                modifier = Modifier
                    .fillMaxWidth(),
                contentAlignment = Alignment.Center
            ) {
                PageTransitionBox(
                    keyValue = selectedService,
                ) {
                    when (selectedService) {
                        "Web Design & Development" -> {
                            ServicesNameBox(
                                "Web Design & Development",
                                selected = selectedService == "Web Design & Development"
                            ) {
                                selectedService = "Web Design & Development"
                            }
                        }

                        "Mobile App Development" -> {
                            ServicesNameBox(
                                "Mobile App Development",
                                selected = selectedService == "Mobile App Development"
                            ) {
                                selectedService = "Mobile App Development"
                            }
                        }

                        "Dev Operation" -> {
                            ServicesNameBox(
                                "Dev Operation",
                                selected = selectedService == "Dev Operation"
                            ) {
                                selectedService = "Dev Operation"
                            }
                        }

                        "Al Development" -> {
                            ServicesNameBox(
                                "Al Development",
                                selected = selectedService == "Al Development"
                            ) {
                                selectedService = "Al Development"
                            }
                        }

                        "UI/UX Design" -> {
                            ServicesNameBox(
                                "UI/UX Design",
                                selected = selectedService == "UI/UX Design"
                            ) {
                                selectedService = "UI/UX Design"
                            }
                        }

                        "AI Chatbot Development" -> {
                            ServicesNameBox(
                                "AI Chatbot Development",
                                selected = selectedService == "AI Chatbot Development"
                            ) {
                                selectedService = "AI Chatbot Development"
                            }
                        }
                    }
                }
            }
        }
    }
    when (selectedService) {
        "Web Design & Development" -> {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Column(horizontalAlignment = if (breakpoint <= Breakpoint.MD) Alignment.CenterHorizontally else Alignment.Start) {
                        SpanText(
                            "Web Design & Development",
                            modifier = titleModifier.cursor(Cursor.Pointer)
                                .onClick { ctx.router.navigateTo("/web-services") }
                        )
                        SpanText(
                            "Our Team specializes in creating responsive, user-friendly websites that drive engagement and performance fom concept to deployment",
                            modifier = descriptionModifier
                        )
                        CommonButton("Learn More", onClick = {
                            println("Web Design Button Clicked")
                            ctx.router.navigateTo("/web-services")
                        }, learnMore = true)

                    }
                    if (breakpoint > Breakpoint.MD) {
                        Column(modifier = Modifier.margin(left = 30.px)) {
                            Row(
                                modifier = Modifier.margin(top = 15.px, bottom = 30.px),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Image(
                                    src = Res.Image.nodesJs_Logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.html_Logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.php_Logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                if (breakpoint > Breakpoint.LG) {
                                    Box(modifier = Modifier.width(15.px)) { }
                                    Image(
                                        src = Res.Image.vueJs_Logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                }

                            }
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Image(
                                    src = Res.Image.laravel_Logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.angular_Logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.javaScript_Logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                if (breakpoint > Breakpoint.LG) {
                                    Box(modifier = Modifier.width(15.px)) { }
                                    Image(
                                        src = Res.Image.bootstrap_Logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                }
                            }
                            if (breakpoint == Breakpoint.LG) {
                                Row(
                                    modifier = Modifier.margin(top = 15.px, bottom = 30.px),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Image(
                                        src = Res.Image.vueJs_Logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                    Box(modifier = Modifier.width(15.px)) { }
                                    Image(
                                        src = Res.Image.bootstrap_Logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                }
                            }
                        }
                    }
                }
                if (breakpoint <= Breakpoint.MD) {
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .padding(
                                top = 30.px,
                                bottom = if (breakpoint == Breakpoint.MD) 20.px else 30.px
                            )
                            .gap(5.px)
                            .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.SpaceAround,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(
                            src = Res.Image.nodesJs_Logo,
                            modifier = Modifier.width(115.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.html_Logo,
                            modifier = Modifier.width(115.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.php_Logo,
                            modifier = Modifier.width(115.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.laravel_Logo,
                            modifier = Modifier.width(115.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.angular_Logo,
                            modifier = Modifier.width(115.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.javaScript_Logo,
                            modifier = Modifier.width(115.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.vueJs_Logo,
                            modifier = Modifier.width(115.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.bootstrap_Logo,
                            modifier = Modifier.width(115.px).height(38.px)
                        )

                    }

                }

            }
        }

        "Mobile App Development" -> {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Row(
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column(horizontalAlignment = if (breakpoint <= Breakpoint.MD) Alignment.CenterHorizontally else Alignment.Start) {
                        SpanText(
                            "Mobile App Development ",
                            modifier = titleModifier
                        )
                        SpanText(
                            "We specialize in creating innovative, user-friendly mobile applications tailored to meet client needs across iOS and Android platforms. ",
                            modifier = descriptionModifier
                        )
                        CommonButton("Learn More", onClick = {
                            ctx.router.navigateTo("/mobile-services")
                        }, learnMore = true)
                    }
                    if (breakpoint > Breakpoint.MD) {
                        Column(modifier = Modifier.margin(left = 30.px)) {
                            Row(
                                modifier = Modifier.margin(top = 15.px, bottom = 30.px),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Image(
                                    src = Res.Image.react_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.flutter_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.swift_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                if (breakpoint > Breakpoint.LG) {
                                    Box(modifier = Modifier.width(15.px)) { }
                                    Image(
                                        src = Res.Image.androidText,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                }

                            }
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Image(
                                    src = Res.Image.ios_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.objC_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.python_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                if (breakpoint > Breakpoint.LG) {
                                    Box(modifier = Modifier.width(15.px)) { }
                                    Image(
                                        src = Res.Image.kotlinText,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                }
                            }
                            if (breakpoint == Breakpoint.LG) {
                                Row(
                                    modifier = Modifier.margin(top = 15.px, bottom = 30.px),
                                    verticalAlignment = Alignment.CenterVertically,
                                ) {
                                    Image(
                                        src = Res.Image.androidText,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                    Box(modifier = Modifier.width(15.px)) { }
                                    Image(
                                        src = Res.Image.kotlinText,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )

                                }
                            }

                        }
                    }
                }
                if (breakpoint <= Breakpoint.MD) {
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .padding(
                                top = 30.px,
                                bottom = if (breakpoint == Breakpoint.MD) 20.px else 30.px
                            )
                            .gap(5.px)
                            .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.SpaceAround,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(
                            src = Res.Image.react_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.flutter_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.swift_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.ios_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.objC_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.python_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.androidText,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.kotlinText,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                    }
                }
            }
        }

        "Dev Operation" -> {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Column(horizontalAlignment = if (breakpoint <= Breakpoint.MD) Alignment.CenterHorizontally else Alignment.Start) {
                        SpanText(
                            "Dev Operations",
                            modifier = titleModifier
                        )
                        SpanText(
                            "Our DevOps services promise a faster yet quality delivery " +
                                    "of products to ensure   excellent results along with Customer satisfaction.",
                            modifier = descriptionModifier
                        )
                        CommonButton(
                            "Learn More",
                            onClick = { ctx.router.navigateTo("/dev-operation") }
                                    ,learnMore = true)
                    }
                    if (breakpoint > Breakpoint.MD) {
                        Column(modifier = Modifier.margin(left = 30.px)) {
                            Row(
                                modifier = Modifier.margin(top = 15.px, bottom = 30.px),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Image(
                                    src = Res.Image.puppet_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.git_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.bamboo_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                if (breakpoint > Breakpoint.LG) {
                                    Box(modifier = Modifier.width(15.px)) { }
                                    Image(
                                        src = Res.Image.jenkins_logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                }
                            }
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Image(
                                    src = Res.Image.docker_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.ansible_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.gradle_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                if (breakpoint > Breakpoint.LG) {
                                    Box(modifier = Modifier.width(15.px)) { }
                                    Image(
                                        src = Res.Image.selenium_logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                }
                            }
                            if (breakpoint == Breakpoint.LG) {
                                Row(
                                    modifier = Modifier.margin(top = 15.px, bottom = 30.px),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Image(
                                        src = Res.Image.jenkins_logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                    Box(modifier = Modifier.width(15.px)) { }
                                    Image(
                                        src = Res.Image.selenium_logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                }
                            }
                        }
                    }
                }
                if (breakpoint <= Breakpoint.MD) {
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .padding(
                                top = 30.px,
                                bottom = if (breakpoint == Breakpoint.MD) 20.px else 30.px
                            )
                            .gap(5.px)
                            .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.SpaceAround,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(
                            src = Res.Image.puppet_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.git_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.bamboo_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.docker_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.ansible_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.gradle_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.jenkins_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.selenium_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )

                    }
                }
            }
        }

        "Al Development" -> {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Column(
                        modifier = Modifier.margin(right = if (breakpoint > Breakpoint.MD) 0.px else 0.px),
                        horizontalAlignment = if (breakpoint <= Breakpoint.MD) Alignment.CenterHorizontally else Alignment.Start
                    ) {
                        SpanText(
                            "Al Development",
                            modifier = titleModifier
                        )
                        SpanText(
                            "At Devxer Technologies, innovation meets intelligence. Our team of experts" +
                                    " utilizes cutting-edge technologies to craft" +
                                    " custom AI solutions that seamlessly integrate with your unique requirements. ",
                            modifier = descriptionModifier
                        )
                        CommonButton("Learn More", onClick = {
                            ctx.router.navigateTo("/ai-services")

                        }, learnMore = true)
                    }
                    if (breakpoint > Breakpoint.MD) {
                        Column (modifier = Modifier.margin(left = 30.px)){
                            Row(
                                modifier = Modifier.margin(top = 15.px, bottom = 30.px),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Image(
                                    src = Res.Image.react_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.angular_Logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                if (breakpoint > Breakpoint.LG) {
                                    Image(
                                        src = Res.Image.laravel_Logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )

                                    Box(modifier = Modifier.width(15.px)) { }

                                    Image(src = Res.Image.netLogo)
                                }

                            }
                            if (breakpoint == Breakpoint.LG) {
                                Row(modifier = Modifier.margin(top = 15.px, bottom = 30.px)) {
                                    Image(
                                        src = Res.Image.laravel_Logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )

                                    Box(modifier = Modifier.width(15.px)) { }

                                    Image(src = Res.Image.netLogo)
                                }
                            }
                            Row {
                                Image(
                                    src = Res.Image.django_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )

                            }
                        }
                    }

                }
                if (breakpoint <= Breakpoint.MD) {
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .padding(
                                top = 30.px,
                                bottom = if (breakpoint == Breakpoint.MD) 20.px else 30.px
                            )
                            .gap(5.px)
                            .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.SpaceAround,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(
                            src = Res.Image.react_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.angular_Logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.laravel_Logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(src = Res.Image.netLogo)
                        Image(
                            src = Res.Image.django_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )

                    }
                }
            }
        }

        "UI/UX Design" -> {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column(
                        modifier = Modifier.margin(right = if (breakpoint > Breakpoint.MD) 100.px else 0.px),
                        horizontalAlignment = if (breakpoint <= Breakpoint.MD) Alignment.CenterHorizontally else Alignment.Start
                    ) {
                        SpanText(
                            "UI/UX Design",
                            modifier = titleModifier
                        )
                        SpanText(
                            "Our team blends creativity with the latest design " +
                                    "trends to create engaging digital products to ensure every interaction is smooth and visually appealing.",
                            modifier = descriptionModifier
                        )
                        CommonButton("Learn More", onClick = {
                            ctx.router.navigateTo("/ui-services")
                        }, learnMore = true)
                    }
                    if (breakpoint > Breakpoint.MD) {
                        Column(modifier = Modifier.margin(left = 30.px)) {
                            Row(
                                modifier = Modifier.margin(top = 15.px, bottom = 30.px),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Image(
                                    src = Res.Image.figma_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.photoShop_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                if (breakpoint > Breakpoint.LG) {
                                    Image(
                                        src = Res.Image.illustrator_logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                }

                            }
                            Row(
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Image(
                                    src = Res.Image.sketch_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.adobeXd_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                if (breakpoint > Breakpoint.LG) {
                                    Box(modifier = Modifier.width(15.px)) { }
                                    Image(
                                        src = Res.Image.after_effect_logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                }
                            }
                            if (breakpoint == Breakpoint.LG) {
                                Row(
                                    modifier = Modifier.margin(top = 15.px, bottom = 30.px),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Image(
                                        src = Res.Image.illustrator_logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                    Box(modifier = Modifier.width(15.px)) { }
                                    Image(
                                        src = Res.Image.after_effect_logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )
                                }
                            }
                        }
                    }
                }
                if (breakpoint <= Breakpoint.MD) {
                    Row(
                        modifier = Modifier.fillMaxWidth
                            ()
                            .padding(
                                top = 30.px,
                                bottom = if (breakpoint == Breakpoint.MD) 20.px else 30.px
                            )
                            .gap(5.px)
                            .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.SpaceAround,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(
                            src = Res.Image.figma_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.photoShop_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.illustrator_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.sketch_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.adobeXd_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.after_effect_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                    }
                }
            }
        }

        "AI Chatbot Development" -> {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Column(
                        modifier = Modifier.margin(right = if (breakpoint > Breakpoint.MD) 80.px else 0.px),
                        horizontalAlignment = if (breakpoint <= Breakpoint.MD) Alignment.CenterHorizontally else Alignment.Start
                    ) {
                        SpanText(
                            "AI Chatbot Development",
                            modifier = titleModifier
                        )
                        SpanText(
                            "Our AI Chatbot Development Services are designed to transform customer" +
                                    " interactions for businesses. We specialize " +
                                    "in crafting Intelligent chatbots that engage in human-like dialogue.",
                            modifier = descriptionModifier
                        )
                        CommonButton("Learn More", onClick = {
                            ctx.router.navigateTo("/chatbot-development")

                        }, learnMore = true)
                    }
                    if (breakpoint > Breakpoint.MD) {
                        Column {
                            Row(
                                modifier = Modifier.margin(top = 15.px, bottom = 30.px),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Image(
                                    src = Res.Image.react_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                Image(
                                    src = Res.Image.angular_Logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                                Box(modifier = Modifier.width(15.px)) { }
                                if (breakpoint > Breakpoint.LG) {
                                    Image(
                                        src = Res.Image.laravel_Logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )

                                    Box(modifier = Modifier.width(15.px)) { }

                                    Image(src = Res.Image.netLogo)
                                }

                            }
                            if (breakpoint == Breakpoint.LG) {
                                Row(modifier = Modifier.margin(top = 15.px, bottom = 30.px)) {
                                    Image(
                                        src = Res.Image.laravel_Logo,
                                        modifier = Modifier.width(127.px).height(38.px)
                                    )

                                    Box(modifier = Modifier.width(15.px)) { }

                                    Image(src = Res.Image.netLogo)
                                }
                            }
                            Row {
                                Image(
                                    src = Res.Image.django_logo,
                                    modifier = Modifier.width(127.px).height(38.px)
                                )
                            }
                        }
                    }
                }
                if (breakpoint <= Breakpoint.MD) {
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .padding(
                                top = 30.px,
                                bottom = if (breakpoint == Breakpoint.MD) 20.px else 30.px
                            )
                            .gap(5.px)
                            .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.SpaceAround,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(
                            src = Res.Image.react_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.angular_Logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(
                            src = Res.Image.laravel_Logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                        Image(src = Res.Image.netLogo)
                        Image(
                            src = Res.Image.django_logo,
                            modifier = Modifier.width(127.px).height(38.px)
                        )
                    }
                }
            }
        }
    }
}

//@Composable
//fun ServiceTransitionBox(
//    keyValue: String,
//    content: @Composable () -> Unit
//) {
//    key(keyValue) {
//        Box(
//            modifier = Modifier
//                .fillMaxWidth()
//                .minHeight(10.px) // prevents jerk
//                .styleModifier {
//                    property("opacity", "1")
//                    property("transform", "translateY(0px)")
//                    property(
//                        "transition",
//                        "opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1), transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
//                    )
//
//                },
//            contentAlignment = Alignment.Center
//        ) {
//            content()
//        }
//    }
//}

@Composable
fun PageTransitionBox(
    keyValue: String,
    content: @Composable () -> Unit
) {
    var visible by remember { mutableStateOf(true) }

    LaunchedEffect(keyValue) {
        visible = false
        delay(500)
        visible = true
    }

    Box(
        modifier = Modifier.styleModifier {
            property("transition", "opacity 0.5s, transform 0.5s")
            property("opacity", if (visible) "1" else "0")
            property("transform",  if (visible) "translateX(0px) scale(1)" else "translateX(50px) scale(0.95)")
        }
    ) {
        content()
    }
}
